<td class="appointment-timeslot-calendar-row" colspan="7">
  <div class="appointment-timeslot-calendar">
    <h3 class="appointment-timeslot-calendar__day"><%= moment.parseZone(slots[0].start_time).format('dddd, MMMM Do, YYYY') %></h3>
    <div class="appointment-timeslot-calendar__slots">
    <% slots.forEach(function(slot) { %>
      <a class="appointment-timeslot-button<% slot.visit_type_categories.forEach(function(category){ %> icon-<%- category %>-visit-filled <% }) %>" translate="no" data-slot-id="<%= slot.id %>" data-testid="<%= testIds.slots.pickerSlot %>" data-analytics-element="slot-picker-calendar-slot" data-analytics-interaction="click" data-analytics-value="<%- moment.parseZone(slot.start_time).format('YYYY-MM-DD') %>" <% if (renderLinks && slot.booking_url != null) { %>href="<%= slot.booking_url %>"<% } %> title="<%- slot.visit_type_categories_description %>" tabindex="0">
        <%= moment.parseZone(slot.start_time).format(I18n.moment_time_format) %>
      </a>
    <% }) %>
    </div>
  </div>
</td>
